import { render, staticRenderFns } from "./course-choose.vue?vue&type=template&id=2324b5dd&"
import script from "./course-choose.vue?vue&type=script&lang=js&"
export * from "./course-choose.vue?vue&type=script&lang=js&"
import style0 from "./course-choose.vue?vue&type=style&index=0&id=2324b5dd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports